import { IonCard, IonCardContent, IonText, useIonToast } from "@ionic/react";
import { alertCircleOutline, barcodeOutline, leafOutline, peopleOutline, personOutline, phonePortraitOutline } from "ionicons/icons";
import { useEffect, useState } from "react";

import ActionButton from "../../../components/button/ActionButton";
import InputItem from "../../../components/input/InputItem";
import RadioItem from "../../../components/radio/RadioItem";
import SlideContent from "../../../components/slide-content/SlideContent";
import { Empty } from "../../../layouts/errors/Empty";
import { DataProvider } from "../../../library/DataProvider";
import { passToWebView } from "../../../library/Funcs";
import { CampaignDownloadDocumentAction } from "../../../redux/actions/Campaign";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import Templates from "../../../components/templates/Template";
import "./NewDoc.css";

interface Props {
  project_id: any;
  seedlings: any;
  docs: any;
  donations: any;
  changeDocs: any;
  templates: [];
}

const NewDoc: React.FC<Props> = (props) => {
  const [toast, dismiss] = useIonToast();
  const dispatch = useAppDispatch();
  const [templateId, setTemplateId] = useState(0);
  const [saplings, setSaplings] = useState([] as any);

  const [dlDocForm, setDlDocForm] = useState({
    donation_id: { value: "", validation: { required: true }, error: "" },
    seedling: { value: "", validation: { required: true }, error: "" },
    saplings: { value: "", validation: { required: true }, error: "" },
    donator: { value: "", validation: { required: true }, error: "" },
    memorial: { value: "", validation: { max: 110 }, error: "" },
    gift_name: { value: "", validation: {}, error: "" },
    gift_mobile: { value: "", validation: {}, error: "" },
  });

  const [dlDocFormProvider] = useState(() => new DataProvider(dlDocForm, setDlDocForm));

  const { form_loading, resp } = useAppSelector((state) => state.campaignDownloadDocument);

  useEffect(() => {
    if (props.seedlings != null) {
      dlDocFormProvider.reset();

      updateSaplings(props.seedlings![0]);
    }
  }, [props.seedlings]);

  useEffect(() => {
    const formDone = () => {
      if (resp != null && !form_loading) {
        if (resp.result) {
          dlDocFormProvider.reset();

          toast({ message: 'پیامک جدید ارسال شد.', duration: 2000, color: "primary" });

          props.changeDocs(resp.docs, resp.seedlings);

          passToWebView("sendPayment", resp.link);
        }
      }
    };

    formDone();
  }, [form_loading]);

  const downloadDocumentFormSubmitHandler = (e: any) => {
    e.preventDefault();

    let formValidation = dlDocFormProvider.validation(dlDocForm);

    if (formValidation) {
      dispatch(
        CampaignDownloadDocumentAction(
          Number(dlDocForm.donation_id.value),
          dlDocForm.seedling.value,
          dlDocForm.saplings.value,
          props.project_id,
          templateId,
          dlDocForm.donator.value,
          dlDocForm.memorial.value,
          dlDocForm.gift_name.value,
          dlDocForm.gift_mobile.value,
        )
      );
    }
  };

  const changeSeedlingHandler = () => {
    props.seedlings!.forEach((el: any) => {
      if (dlDocForm.seedling.value == el.id) {
        updateSaplings(el.treeRemain!);
      }
    });
  };

  const updateSaplings = (treeRemain?: number) => {
    if (props.seedlings!.length == 0) return;

    const saps = [];

    saps.push({ count: 0, label: "همه نهال ها" });

    [...Array(treeRemain!)].forEach((item, i) => {
      saps.push({ count: i + 1, label: (i + 1).toString() });
    });

    setSaplings(saps);
  };

  return (
    <SlideContent class="new-doc" type="segment">
      <IonCard>
        <Empty length={props.seedlings?.length} icon={alertCircleOutline} text="امکان دریافت سند جدید وجود ندارد!">
          <IonCardContent>
            <form onSubmit={downloadDocumentFormSubmitHandler}>
              <InputItem name="seedling" type="select2" label="نوع نهال" icon={leafOutline} provider={dlDocFormProvider} change={changeSeedlingHandler}>
                {props.seedlings?.map((item: any) => {
                  return <RadioItem value={item.id} label={item.type} />;
                })}
              </InputItem>
              <InputItem name="saplings" type="select2" label="تعداد نهال" icon={leafOutline} provider={dlDocFormProvider}>
                {saplings?.map((item: any) => {
                  return <RadioItem value={item.count} label={item.label} />;
                })}
              </InputItem>
              <InputItem name="donation_id" type="select2" label="کد پیگیری / تاریخ" icon={barcodeOutline} provider={dlDocFormProvider}>
                {props.donations?.map((item: any) => {
                  return <RadioItem value={item.id} label={item.transaction_id != 0 ? item.transaction_id + " - " + item.date : item.date} />;
                })}
              </InputItem>

              <div>
                <p className="note-text">
                  جهت دریافت سند درخت، <strong>نام اهداکننده</strong> و <strong>متن یادبود</strong> را تکمیل کنید. چنانچه مبلغ پرداختی شما حداقل به مقدار 1 نهال
                  باشد امکان دریافت سند را پس از پرداخت خواهید داشت.
                </p>

                <p className="note-text-danger">از درج ایموجی و شکلک ها در قسمت های نام اهداکننده، متن یادبود و نام هدیه گیرنده خودداری کنید.</p>
              </div>
              <InputItem name="donator" type="text" label="نام اهدا کننده / از طرف"  maxlength={50} icon={personOutline} provider={dlDocFormProvider} />
              <InputItem name="memorial" type="text"label="متن یادبود (زیر سند درج می شود)" maxlength={110} icon={peopleOutline} provider={dlDocFormProvider} />

              <div>
                <p className="note-text">
                  اگر قصد دارید سند درخت را به شخصی هدیه کنید <strong>نام</strong> و <strong>تلفن همراه</strong> هدیه گیرنده را تکمیل کنید. یک
                  پیامک حاوی لینک سند درخت برایشان ارسال خواهد شد.
                </p>
                <p className="note-text-danger">در قسمت نام هدیه گیرنده فقط نام را نوشته و از درج عبارت "به نیابت از" خودداری کنید.</p>
              </div>
              <InputItem
                name="gift_name"
                type="text"
                label="نام هدیه گیرنده (به نیابت از ...)"
                icon={personOutline}
                maxlength={50}
                provider={dlDocFormProvider}
              />
              <InputItem
                name="gift_mobile"
                type="tel"
                label="تلفن همراه هدیه گیرنده"
                icon={phonePortraitOutline}
                maxlength={11}
                ltr
                provider={dlDocFormProvider}
              />

              {<Templates type={"tree"} templates={props.templates} templateId={templateId} setTemplateId={setTemplateId} donator={dlDocForm.donator.value} giftName={dlDocForm.gift_name.value} memorial={dlDocForm.memorial.value} />}
              <ActionButton text="دریافت سند" loading={form_loading}></ActionButton>
            </form>
          </IonCardContent>
        </Empty>
      </IonCard>
    </SlideContent>
  );
};

export default NewDoc;
